module.exports = __webpack_public_path__ + "img/egame_ka.d5b18887.png";